import { getFunctions, httpsCallable } from "firebase/functions";
import config from "./../../config.json";
import { getApp } from "firebase/app";

export function adminGetAllActiveShopForShopify() {
  const functions = getFunctions(getApp(), config.australiaSoutheast);
  const allTransports = httpsCallable(
    functions,
    config.adminGetAllActiveShopForShopify
  );
  return allTransports();
}
